import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Layout from '../components/layout/Layout';

const NotFound = () => {
  return (
    <Layout>
      <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 py-12">
        <div className="text-center max-w-md">
          <h1 className="text-9xl font-bold text-primary">404</h1>
          <h2 className="text-3xl font-semibold mt-4 mb-6">Stran ni najdena</h2>
          <p className="text-gray-600 mb-8">
            Oprostite, iskane strani ni mogoče najti. Morda je bila premaknjena, izbrisana ali pa ste vnesli napačen URL.
          </p>
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 justify-center">
            <Link
              to="/"
              className="btn-primary"
            >
              <Home className="mr-2 h-5 w-5" />
              Domov
            </Link>
            <button
              onClick={() => window.history.back()}
              className="btn-outline"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Nazaj
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;